import { render, staticRenderFns } from "./env-charts.vue?vue&type=template&id=3920386f&scoped=true"
import script from "./env-charts.vue?vue&type=script&lang=js"
export * from "./env-charts.vue?vue&type=script&lang=js"
import style0 from "./env-charts.vue?vue&type=style&index=0&id=3920386f&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3920386f",
  null
  
)

export default component.exports